/**
 * This module provides the form handler for the Battery Settings of a Storage device.
 *
 * It uses a work in progress implementation of the Formik form handler.
 *
 * The goal of the WIP here is:
 * - to demonstrate how Formik can be integrated
 * - to demonstrate how Formik behaves
 * - test how existing customized component react with Formik
 *
 * With the results we can:
 * - decide if we continue working with it
 * - decide how to model a generic Form component
 * - decide how to model Input component which require the Form connectors
 */
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { BatteryModel } from 'src/Libs/batteries'
import VoltageAdjustmentFieldSet from 'src/Elements/SystemSettings/Battery/settings/VoltageAdjustmentFieldSet'
import SettingsFormContainer from '../../forms/SettingsFormContainer'

interface Props {
  model: BatteryModel
  allowAccess?: boolean
}

/**
 * TODO: the usage of allowAccess is probably wrong here, as it tmp disabled the switch. but the input itself can again be enabled. the intention of `allowAccess` in this case is probably to only display the value, without providing additional interaction options.
 * @param model
 * @param allowAccess
 * @constructor
 */
const BatterySettingsForm: React.VFC<Props> = ({ model, allowAccess = true }) => {
  const { t } = useCustomTranslation()

  return (
    <SettingsFormContainer model={model}>
      <VoltageAdjustmentFieldSet
        valueFieldName="voltage"
        stateFieldName="isAdjustmentEnabled"
        label={t('systemSettings.battery.settings.voltage')}
        boundaries={model.voltageAdjustment}
        disabled={!allowAccess}
      />
    </SettingsFormContainer>
  )
}

export default BatterySettingsForm
